import { Routes } from '@angular/router';
import { AuthGuard } from './core';

export const routes: Routes = [

    {
        path: '',
        redirectTo: 'department-selection',
        pathMatch: 'full'
    },
    {
        path: 'department-selection',
        loadComponent: () => import('./modules/dashboard/components/department-selection/department-selection.component').then(com => com.DepartmentSelectionComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'job-operation',
        loadComponent: () => import('./modules/index').then(com => com.JobOperationViewComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'operation-create',
        loadComponent: () => import('./modules/index').then(com => com.OperationCreateComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'machine-timeline',
        loadComponent: () => import('./modules/index').then(com => com.MachineTimelineComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./modules/index').then(com => com.DashboardComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'shift-roster',
        loadComponent: () => import('./modules/index').then(com => com.ShiftRosterComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'operation-shift',
        loadComponent: () => import('./modules/index').then(com => com.OperationShiftComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'machine-output',
        loadComponent: () => import('./modules/index').then(com => com.OperatorOutputComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'machine-dashboard',
        loadComponent: () => import('./modules/index').then(com => com.MachineDashboardComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'operator-dashboard',
        loadComponent: () => import('./modules/index').then(com => com.OperatorDashboardComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'shift-management',
        loadComponent: () => import('./modules/index').then(com => com.ShiftManagementComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'machine-comparison',
        loadComponent: () => import('./modules/index').then(com => com.MachineComparisonComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'operation-schedule',
        loadComponent: () => import('./modules/index').then(com => com.OperationScheduleComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'manual-sorting',
        loadComponent: () => import('./modules/index').then(com => com.ManualSortingComponent),
        canActivate: [AuthGuard],
    }, 
    {
        path: 'call-out',
        loadComponent: () => import('./modules/index').then(com => com.CallOutMainComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'machine-output-dashboard',
        loadComponent: () => import('./modules/index').then(com => com.MachineOutputDashboardComponent),
        canActivate: [AuthGuard],
    }


];
